import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const deleteSensitiveTool = (toolName, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETING_SENSITIVE_TOOL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.delete(
            `/ads/sensitive-tools/${encodeURIComponent(toolName)}`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'DELETING_SENSITIVE_TOOL_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'DELETING_SENSITIVE_TOOL_FAILED',
              payload: `Failed to remove sensitive tool`,
            });
            if (typeof errCb === 'function') {
              errCb(`Failed to remove sensitive tool`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'DELETING_SENSITIVE_TOOL_FAILED',
            payload: `Failed to remove sensitive tool`,
          });
          if (typeof errCb === 'function') {
            errCb(
              e?.response?.status === 401
                ? `You need the ROLE_ADMIN role to remove a sensitive tool`
                : e?.response?.data?.message ||
                    `Failed to remove sensitive tool`,
            );
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'DELETING_SENSITIVE_TOOL_FAILED',
        payload: `Failed to remove sensitive tool`,
      });
      if (typeof errCb === 'function') {
        errCb(`Failed to remove sensitive tool`);
      }
    }
  };
};

export default deleteSensitiveTool;
